// Sprint ONBOARD ONB.C1 (A.3) — placeholder for the per-integration setup
// sub-wizards. A.4 (ONB.C2, GitHub) replaces the element at
// /setup/connect-github; A.5 (ONB.C3, Drive) replaces /setup/authorize-gdrive.
// Until then this renders a clearly-identifiable "coming soon" page so the
// route is not mistaken for a broken link, with a way back to the wizard.

import { useNavigate } from 'react-router-dom';

export default function SetupSubWizardPlaceholder() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="setup-subwizard-placeholder"
      style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', background: 'var(--bg)' }}
    >
      <div style={{ width: '100%', maxWidth: 460, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl, 16px)', boxShadow: 'var(--shadow-lg)', padding: 40, textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, color: 'var(--text)', margin: '0 0 8px' }}>
          This step is coming soon
        </h1>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--text-secondary)', margin: '0 0 24px', lineHeight: 1.5 }}>
          We&rsquo;re putting the finishing touches on this setup step. Check back shortly.
        </p>
        <button
          data-testid="setup-subwizard-back"
          onClick={() => navigate('/setup')}
          style={{ fontFamily: 'var(--font-body)', fontSize: 15, fontWeight: 600, padding: '10px 24px', background: 'var(--primary, #7c3aed)', color: '#fff', border: 'none', borderRadius: 'var(--radius-sm, 8px)', cursor: 'pointer' }}
        >
          Back to setup
        </button>
      </div>
    </div>
  );
}
